import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthBase } from './auth.base';
import { ConnectionService } from '../services/connection/connection.service';
import { AuthenticationService } from '../../user/services/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class LoadGuard extends AuthBase implements CanLoad {
    constructor(authenticationService: AuthenticationService,
                connectionService: ConnectionService) {
        super(authenticationService, connectionService);
    }

    /**
     * For now load and activate guards share the same logic as there are no roles
     * this is there as placeholder for actual implementation
     */
    public canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkAuthorization();
    }
}
